import React, { useEffect } from 'react';
import { fetchUsers } from '../../../redux/slices/Admin/UsersSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
const Users =() => {
    const {users} = useSelector((state:any) => state.adminUsers)
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    useEffect(() => {
        dispatch(fetchUsers());
    },[dispatch])
    return (
        <>
            Users 
            {users !== undefined && users.map((user) => 
                <p> {user.email}</p>
            )}
        </>
    )
}

export default Users;
